/**
 * @generated SignedSource<<b6af2e5e8b1c672924f300605e9d9ac3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type useUpdateCommentInCacheReplyFragment$data = {
  readonly author: {
    readonly __typename: string;
    readonly accountId?: string | null;
    readonly displayName: string | null;
    readonly permissionType: SitePermissionType | null;
    readonly profilePicture: {
      readonly path: string;
    } | null;
  };
  readonly body: {
    readonly value: string;
  };
  readonly contentStatus: string;
  readonly createdAt: {
    readonly value: string;
  };
  readonly createdAtNonLocalized: string;
  readonly id: string;
  readonly links: {
    readonly editui: string | null;
    readonly webui: string | null;
  };
  readonly location: {
    readonly __typename: string;
    readonly commentResolveProperties?: {
      readonly resolved: boolean;
      readonly resolvedFriendlyDate: string | null;
      readonly resolvedTime: AGG$Long | null;
      readonly resolvedUser: string | null;
    } | null;
    readonly inlineMarkerRef?: string | null;
    readonly inlineResolveProperties?: {
      readonly isDangling: boolean;
      readonly resolved: boolean;
      readonly resolvedFriendlyDate: string | null;
      readonly resolvedTime: AGG$Long | null;
      readonly resolvedUser: string | null;
    } | null;
    readonly inlineText?: string | null;
    readonly type: string;
  };
  readonly parentId: string | null;
  readonly permissions: {
    readonly isEditable: boolean;
    readonly isRemovable: boolean;
    readonly isResolvable: boolean;
  };
  readonly version: {
    readonly by: {
      readonly __typename: string;
      readonly displayName: string | null;
    } | null;
    readonly number: number | null;
    readonly when: string | null;
  };
  readonly " $fragmentType": "useUpdateCommentInCacheReplyFragment";
};
export type useUpdateCommentInCacheReplyFragment$key = {
  readonly " $data"?: useUpdateCommentInCacheReplyFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useUpdateCommentInCacheReplyFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v1 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v2 = [
  {
    "kind": "ScalarField",
    "name": "value"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "resolved"
},
v4 = {
  "kind": "ScalarField",
  "name": "resolvedFriendlyDate"
},
v5 = {
  "kind": "ScalarField",
  "name": "resolvedTime"
},
v6 = {
  "kind": "ScalarField",
  "name": "resolvedUser"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useUpdateCommentInCacheReplyFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "LinkedField",
      "name": "author",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "kind": "ScalarField",
          "name": "permissionType"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "accountId"
            }
          ],
          "type": "KnownUser"
        },
        {
          "concreteType": "Icon",
          "kind": "LinkedField",
          "name": "profilePicture",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "path"
            }
          ]
        }
      ]
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "representation",
          "value": "ATLAS_DOC_FORMAT"
        }
      ],
      "concreteType": "DocumentBody",
      "kind": "LinkedField",
      "name": "body",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    },
    {
      "kind": "ScalarField",
      "name": "contentStatus"
    },
    {
      "concreteType": "ConfluenceDate",
      "kind": "LinkedField",
      "name": "createdAt",
      "plural": false,
      "selections": (v2/*: any*/)
    },
    {
      "kind": "ScalarField",
      "name": "createdAtNonLocalized"
    },
    {
      "concreteType": "Map_LinkType_String",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "editui"
        },
        {
          "kind": "ScalarField",
          "name": "webui"
        }
      ]
    },
    {
      "kind": "LinkedField",
      "name": "location",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "name": "type"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "InlineCommentResolveProperties",
              "kind": "LinkedField",
              "name": "commentResolveProperties",
              "plural": false,
              "selections": [
                (v3/*: any*/),
                (v4/*: any*/),
                (v5/*: any*/),
                (v6/*: any*/)
              ]
            }
          ],
          "type": "FooterComment"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "inlineMarkerRef"
            },
            {
              "concreteType": "InlineCommentResolveProperties",
              "kind": "LinkedField",
              "name": "inlineResolveProperties",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "isDangling"
                },
                (v3/*: any*/),
                (v4/*: any*/),
                (v5/*: any*/),
                (v6/*: any*/)
              ]
            },
            {
              "kind": "ScalarField",
              "name": "inlineText"
            }
          ],
          "type": "InlineComment"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "parentId"
    },
    {
      "concreteType": "CommentPermissions",
      "kind": "LinkedField",
      "name": "permissions",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isEditable"
        },
        {
          "kind": "ScalarField",
          "name": "isRemovable"
        },
        {
          "kind": "ScalarField",
          "name": "isResolvable"
        }
      ]
    },
    {
      "concreteType": "Version",
      "kind": "LinkedField",
      "name": "version",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "by",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/)
          ]
        },
        {
          "kind": "ScalarField",
          "name": "number"
        },
        {
          "kind": "ScalarField",
          "name": "when"
        }
      ]
    }
  ],
  "type": "Comment"
};
})();

(node as any).hash = "d793bb57d64855b11bf515ef7082e802";

export default node;
